export default "__VITE_ASSET__K9_Qry2f__"